import {
  Button,
  Modal,
  notification,
  Popconfirm,
  Space,
  Table,
  Typography,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { useHistory } from "react-router-dom";
import { ReactComponent as AddFileGray } from "../../../../assets/images/upload-file-gray.svg";
import { useState } from "react";
import API_SERVICE from "shared/services/api-service";
import { saveByteArray } from "shared/services/Utility";
import { ReactComponent as Information } from "../../../../assets/images/information.svg";
import deletefile from "../../../../../src/assets/images/delete.svg";
import { RootState } from "shared/redux/store";
import { useSelector } from "react-redux";

const { Text } = Typography;

const BulkUpdateStartImport: React.FunctionComponent<{
  setActiveStepKey: any;
  setFileName: any;
}> = (props) => {
  const history = useHistory();
  const [uploadFile, setUploadFile] = useState({} as any);
  const [isopenStart, setIsopenStart] = useState(true);
  const [allowedAttechmentTypes] = useState([
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ]);
  const { setActiveStepKey } = props;
  const filePlaceholder = "Drag or Drop your file here";
  const [selectedFileName, setSelectedFileName] = useState(filePlaceholder);
  const { setFileName } = props;
  const [isRemove, setIsRemove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isUserGuideModalOpen, setIsUserGuideModalOpen] = useState(false);
  const { appColors }: any = useSelector((state: RootState) => state.common);

  const onBulkUploadChange = (file: any) => {
    if (isRemove) {
      setIsRemove(false);
    }
    setUploadFile(file);
    setSelectedFileName(file?.file?.name);
  };

  const goToUploadImportBulkUpload = () => {
    if (isRemove || !uploadFile.file?.name) {
      notification.error({ message: "Please select file" });
      return;
    }

    if (allowedAttechmentTypes.indexOf(uploadFile.file.type) === -1) {
      notification.error({ message: "Please attach only .xlsx file." });
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadFile.file);
    setLoading(true);
    const entityType = "UPDATE_LEAD";
    API_SERVICE.bulkUploadStart(entityType, formData)
      .then(({ data }) => {
        if (data) {
          localStorage.setItem("uploadId", data.payload.uploadId);
          setIsopenStart(false);
          setActiveStepKey(2);
          setFileName(selectedFileName);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setLoading(false));
  };

  const handleDownload = () => {
    API_SERVICE.getDownloadFormate("UPDATE_LEAD")
      .then(({ data }) => saveByteArray([data], "update_status_lead.xlsx"))
      .catch(async (e: any) => {
        const data = JSON.parse(await e.response.data.text());
        const message = data?.payload?.errorMessage ?? e;
        notification.error({ message: API_SERVICE.handleErrors(message) });
      });
  };

  const onFileRemove = () => {
    setSelectedFileName(filePlaceholder);
    if (!isRemove) {
      setIsRemove(true);
    }
  };

  const onClickUserGuide = () => {
    setIsUserGuideModalOpen(true);
  };

  const onOkUserGuideModal = () => {
    setIsUserGuideModalOpen(false);
  };

  const onCancelUserGuideModal = () => {
    setIsUserGuideModalOpen(false);
  };

  const columnForNote = [
    {
      title: "Loan ID",
      dataIndex: "loanId",
      key: "loanId",
    },
    {
      title: "Loan Product Value",
      dataIndex: "loanProductValue",
      key: "loanProductValue",
    },
    {
      title: "Loan Product Name",
      dataIndex: "loanProductName",
      key: "loanProductName",
    },
  ];

  const onDeleteDoc = () => {
    setSelectedFileName(filePlaceholder);
    if (!isRemove) {
      setIsRemove(true);
    }
  };

  const customStylesBtn: any = {
    "--borderColor": appColors?.appSecondaryColor ?? "",
    marginLeft: "10px",
  };
  const customStylesBtnPrimary: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    marginRight: "10px",
  };
  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };

  const renderUserGuide = () => {
    return (
      <Modal
        footer={false}
        width={1000}
        title="Note:"
        visible={isUserGuideModalOpen}
        onOk={onOkUserGuideModal}
        onCancel={onCancelUserGuideModal}
      >
        <div style={{ fontWeight: "300" }}>
          1. Ensure Case ID is correctly entered in Column A
        </div>
        <div style={{ fontWeight: "300" }}>
          2. Ensure Lender Name (Column E) is selected from the drop down list only
        </div>
        <div style={{ fontWeight: "300" }}>
          3. If case is rejected, ensure Rejected Reason (Column F) is selected from the drop down list only
        </div>
        <div style={{ fontWeight: "300" }}>
          4. If case is sanctioned, ensure Sanctioned Amount (Column G) is entered correctly and Sanctioned Date (Column H) is filled in the given format only
        </div>
        <div style={{ fontWeight: "300" }}>
          5. If case is withdrawn, ensure Withdrawn Reason (Column J) is selected from the drop down list only
        </div>
        <div style={{ fontWeight: "300" }}>
          6. If case is in pendency, ensure Pendency Reason (Column K) is selected from the drop down list only
        </div>
        <div style={{ fontWeight: "300" }}>
          7. If a case is disbursed, ensure correct values are filled in Disbursed Amount (Column L) and Disbursed Date (Column N)
        </div>
        <div style={{ fontWeight: "300" }}>
          8. Ensure only numeric values are put in the following columns (if applicable):
        </div>
        <div style={{ marginLeft: "16px", fontWeight: "300" }}>
            -Sanctioned Amount (Column G)
        </div>
        <div style={{ marginLeft: "16px", fontWeight: "300" }}>
            -Interest Rate (Column I)
        </div>
        <div style={{ marginLeft: "16px", fontWeight: "300" }}>
            -Disbursed Amount (Column L)
        </div>
        <div style={{ marginLeft: "16px", fontWeight: "300" }}>
            -Insurance Amount (Column M)
        </div>
        <div style={{ marginLeft: "16px", fontWeight: "300", marginBottom:'20px' }}>
            -Connector Payout % (Column O)
        </div>
        {/* <Table
          columns={columnForNote}
          dataSource={listOfLoanDetails}
          className="dynamic-pagination-checkbox"
          style={customStyles}
        /> */}
      </Modal>
    );
  };

  return (
    <>
      {isopenStart && (
        <div>
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Text>
                <h4>Status Update Of Leads</h4>
              </Text>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="link"
                onClick={handleDownload}
                className="bulk-upload-border-primary-btn"
                style={customStyles}
              >
                Lead status update .xlsx template
              </Button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px",
                height: "200px",
              }}
            >
              <Dragger
                style={{
                  width: "600px",
                  height: "400px",
                  borderRadius: "20px",
                }}
                accept=".xlsx,"
                name="bulkUpload"
                maxCount={1}
                beforeUpload={() => {
                  return false;
                }}
                onChange={onBulkUploadChange}
                onRemove={onFileRemove}
                showUploadList={false}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "10px",
                    }}
                  >
                    <Space className=" start-import-upload-icon ">
                      <AddFileGray width={60} height={60} />
                    </Space>
                  </div>
                  <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Text>
                        {isRemove
                          ? "Drag or Drop your file here"
                          : selectedFileName}
                      </Text>
                    </div>
                  </div>
                </div>
              </Dragger>
              <div
                style={{
                  border: "none",
                  marginLeft: "-35px",
                  marginTop: "25px",
                  zIndex: "1",
                }}
              >
                <img src={deletefile} onClick={onDeleteDoc} alt="" width={20} />
              </div>
            </div>
          </div>

          <div>
            <p
              className="bulk-uplopad-span"
              style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
            >
              <Information
                style={
                  {
                    "--bgColor": appColors?.appSecondaryColor ?? "",
                    width: "30px",
                  } as any
                }
              />
              <span style={{ cursor: "pointer" }} onClick={onClickUserGuide}>
                {" "}
                User Guide - How to Status Update
              </span>
            </p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <Button
              className="bulk-upload-btn  dynamic-btn-primary"
              style={customStylesBtnPrimary}
              type="primary"
              loading={loading}
              onClick={() => goToUploadImportBulkUpload()}
            >
              Next
            </Button>

            <Popconfirm
              title="Your uploaded file will be deleted"
              onConfirm={(event) => history.goBack()}
              okButtonProps={{
                style: {
                  backgroundColor: appColors?.appPrimaryColor ?? "#273896",
                  border: "none",
                },
              }}
              cancelButtonProps={{
                style: {
                  borderColor: appColors?.appSecondaryColor ?? "#C71C8E",
                  color: appColors?.appSecondaryColor ?? "#C71C8E",
                },
              }}
            >
              <Button
                className="bulk-upload-btn  dynamic-btn-default"
                style={customStylesBtn}
                // onClick={() => { history.goBack() }}
              >
                Back
              </Button>
            </Popconfirm>
          </div>
        </div>
      )}
      {renderUserGuide()}
    </>
  );
};

export default BulkUpdateStartImport;
